import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MapView from '../views/MapView.vue'
import NewHiYouCai from '../views/newHiYouCai.vue'
import UserInfo from '../views/userInfo.vue'
import EditTable from '../views/editTable.vue'
// import { component } from 'vue/types/umd'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    component: MapView
  },
  {
    path: '/home',
    name: 'home1',
    component: MapView
  },
  {
    path: '/hiYouCai',
    name: 'hiYouCai',
    component:() => import(/* webpackChunkName: "about" */ '../views/hiYouCai.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },

  {
    path: '/map',
    name: 'map',
    component: HomeView
  },
  {
    path: '/newHiYouCai',
    name: 'newHiYouCai',
    component: NewHiYouCai
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: UserInfo
  },
  {
    path: '/editTable',
    name: 'editTable',
    component: EditTable
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
